import { memoize } from '@exodus/basic-utils';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import lodash from 'lodash';
import { createSelector } from 'reselect';
const selectorFactory = (dataSelector) => memoize((path) => createSelector(dataSelector, (data) => lodash.get(data, path)));
const getSelectorDefinition = defineSelectorFactory({
    id: 'get',
    selectorFactory,
    dependencies: [{ selector: 'data' }],
});
export default getSelectorDefinition;
